import { state } from '../store/state'
import elements from '../store/elements'
import { shopifyCartAPIAdd } from '../../../api/shopify/shopifyCartAPI.add'

const formData = () => {
  const ret = {
    id: state.variant.id,
    quantity: 1,
    properties: {}
  }

  // add props:
  elements.form.querySelectorAll('input[type="hidden"][name*="properties"], input[type="radio"][name*="properties"]:checked').forEach(elem => {
    ret.properties[elem.name.slice(elem.name.indexOf('[') + 1, elem.name.lastIndexOf(']'))] = elem.value
  })

  return ret
}

const addAjax = () => {
  elements.form.addEventListener('submit', event => {
    event.preventDefault()

    elements.addButton.classList.add('loading')

    const queryData = formData()

    shopifyCartAPIAdd([queryData]).then(({ items }) => {
      elements.addButton.classList.remove('loading')
      queryData.itemData = items[items.length - 1]
      document.dispatchEvent(new window.CustomEvent('addToCart', {
        detail: queryData
      }))
    })
  })
}

export default addAjax
